import { LoadingView } from 'components';
import { SigningDocuments } from 'modules/onboarding/common/components/SigningDocuments';
import { useClientSigningDocuments } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from '../hooks/useOnboardingContext';

export const SigningDocumentsStep = () => {
  const { data } = useOnboardingContext();

  const { onClickDocument, onSubmit, formError, loading, documents } =
    useClientSigningDocuments(data);

  if (loading || !documents) {
    return <LoadingView />;
  }

  return (
    <SigningDocuments
      documents={documents}
      formError={formError}
      onClickDocument={onClickDocument}
      onSubmit={onSubmit}
    />
  );
};
